import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token';
const TokenKeyZtb = 'Admin-Token-Ztb';

export function getToken() {
  return Cookies.get(TokenKeyZtb)
}

export function setToken(token) {
  return Cookies.set(TokenKeyZtb, token)
}




export function setTokenZtb(token) {
  return Cookies.set(TokenKeyZtb, token)
}

export function removeToken() {
  return Cookies.remove(TokenKeyZtb)
}
